$(document).ready(function () {
  $('.cookies_popup_wrap ._accept').on('click', function(e) {
    localStorage.setItem('cookie', 1);
    $('.cookies_popup').removeClass('_active');
    return true;
  });

  $('.cookies_popup_wrap ._decline').on('click', function(e) {
    localStorage.setItem('cookie', 0);
    $('.cookies_popup').removeClass('_active');
    return true;
  });

  if (!localStorage.getItem('cookie')) {
    setTimeout(() => {
      $('.cookies_popup').addClass('_active');
    }, 4000);
  }
});